import React from 'react'
import { createUseStyles } from 'react-jss'

// .loader {
// 	width: 48px;
// 	height: 48px;
// 	border: 5px solid #FFF;
// 	border-bottom-color: #FF3D00;
// 	border-radius: 50%;
// 	display: inline-block;
// 	box-sizing: border-box;
// 	animation: rotation 1s linear infinite;
// 	}

// 	@keyframes rotation {
// 	0% {
// 			transform: rotate(0deg);
// 	}
// 	100% {
// 			transform: rotate(360deg);
// 	}
// 	}

const useStyles = createUseStyles(() => ({
    spinner: {
        width: '100vw',
        height: '100dvh',
        display: 'flex',
        position: 'fixed',
        top: 0,
        alignItems: 'center',
        justifyContent: 'center',
        left: '0',
        zIndex: 4,
    },
    loader: {
        position: 'relative',
    },
}))

const Loader: React.FC = () => {
    const classes = useStyles()
    return (
        <div className={classes.loader}>
            <div className="loader" />
        </div>
    )
}

const Spinner: React.FC = () => {
    const classes = useStyles()
    return (
        <div className={classes.spinner}>
            <div className="lds-spinner">
                <div />
                <div />
                <div />
                <div />
                <div />
                <div />
                <div />
                <div />
                <div />
                <div />
                <div />
                <div />
            </div>
        </div>
    )
}

export { Spinner, Loader }
